export default __webpack_public_path__ + "static/media/zopie.a5046e30.svg";